import { Container, Row, Col, Card, CardBody } from "reactstrap";
import React from "react";

const PaymenFailed = () => {
  return (
    <React.Fragment>
      <Container
        style={{ display: "flex", justifyContent: "center", marginTop: "40px" }}
      >
        <Card>
          <CardBody>
            <Row>
              <Col md="12">
							  <br/>
                <div style={{ textAlign: "center" }}>
                  <h1>
                    <span className="mdi mdi-close-circle-outline" style={{ fontSize: "3em", color:'#f75454' }}></span>
                  </h1>
                  <h3>PAYMENT FAILED</h3>
                </div>
								<br/>
              </Col>
              <Col md="12">
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <button className="btn btn-primary" onClick={() => (window.location.href = "/")}>Click to Return</button>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </React.Fragment>
  );
};

export default PaymenFailed;
